/* Copyright (c) 2020-present CloudIO Inc */

import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export const useHeaderStyles = makeStyles((theme: Theme) => ({
  head: {
    lineHeight: 'unset',
    fontWeight: theme.typography.fontWeightBold,
    display: 'flex',
    alignItems: 'center',
    '&:hover > $icons > $moreIcon': {
      display: 'inline',
    },
    '&$dragging &:hover > $icons > $moreIcon': {
      display: 'inline',
    },
  },
  center: {
    textAlign: 'center',
    '& $label': {
      justifyContent: 'center',
    },
  },
  start: {
    textAlign: 'start',
    '& $label': {
      justifyContent: 'flex-start',
    },
  },
  end: {
    textAlign: 'end',
    '& $label': {
      justifyContent: 'flex-end',
    },
  },
  label: {
    flex: 1,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  icons: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
  },
  sortIcon: {
    marginRight: 8,
  },
  moreIcon: {
    marginRight: 8,
    display: 'none',
  },
  dragging: {},
  draggingThis: {
    backgroundColor: theme.palette.background.paper,
    zIndex: 99999,
  },
  sortable: {
    cursor: 'pointer',
  },
}));

export const useCellStyles = makeStyles((theme: Theme) => ({
  cell: {
    lineHeight: 'unset',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    outline: 'none',
    userSelect: 'text',
  },
  overflowVisible: {
    overflow: 'visible',
  },
  error: {
    background: theme.palette.error.light,
  },
  input: {
    lineHeight: 'unset',
    border: 0,
    width: '100%',
    padding: 0,
    margin: 0,
    background: theme.palette.background.paper,
    color: theme.palette.text.primary,
  },
  numberInput: {
    MozAppearance: 'textfield',
    '&::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
    },
  },
  center: {
    textAlign: 'center',
  },
  start: {
    textAlign: 'start',
  },
  end: {
    textAlign: 'end',
  },
}));

export const useFlexCellStyles = makeStyles((theme: Theme) => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    outline: 'none',
  },
  center: {
    justifyContent: 'center',
  },
  start: {
    justifyContent: 'flex-start',
  },
  end: {
    justifyContent: 'flex-end',
  },
}));
